import React from 'react';
import { Link } from "react-router-dom"
import CodeBox from '../TailwindUI/CodeBox';

const DocIndex = () => {

    const configFile =
        `
    /** @type {import('tailwindcss').Config} */

        module.exports = {
            content: ["./src/**/*.{js,jsx,ts,tsx}"],
            theme: {
            extend: {},
            },
            plugins: [],
        }
        `

    // {/* x---------------------------------x Project Structure Code Section x---------------------------------x */}
    const ProjectStructure = (
        <div className='text-start ps-5'>
            <ul className="list-none space-y-2">
                <li className="text-red-500">
                    <span className="inline-block min-w-[120px]">node_modules</span>
                    <small className="text-gray-500">(NPM dependencies, by default not included, npm installs dependencies.)</small>
                </li>
                <li>
                    src
                    <ul className="border-l pl-4">
                        <li>assets
                            <ul className="border-l pl-4">
                                <li>fonts</li>
                                <li>images</li>
                                <li>scss</li>
                            </ul>
                        </li>
                        <li>Common</li>
                        <li>Layout
                            <ul className="border-l pl-4">
                                <li>AdminLayout</li>
                                <li>AuthLayout</li>
                            </ul>
                        </li>
                        <li className="text-red-500 before:content-['⮟'] before:mr-3">Partials
                            <ul className="border-l pl-4">
                                <li className="text-primary">Accounts</li>
                                <li className="text-primary">CreditCard</li>
                                <li className="text-primary">DashBoard</li>
                                <li className="text-primary">Invesment</li>
                                <li className="text-primary">Loans</li>
                                <li className="text-primary">Privileges</li>
                                <li className="text-primary">Services</li>
                                <li className="text-primary">Setting</li>
                                <li className="text-primary">Transaction</li>
                            </ul>
                        </li>
                        <li className="text-red-500 before:content-['⮟'] before:mr-3">Tuning
                            <ul className="border-l pl-4">
                                <li className='text-primary'>Authentication
                                    <ul className="border-l pl-4 text-dark">
                                        <li>LockScreen</li>
                                        <li>Maintenance</li>
                                        <li>NoPageFound</li>
                                        <li>PosswordReset</li>
                                        <li>SignIn</li>
                                        <li>SignUp</li>
                                        <li>TwoStep</li>
                                    </ul>
                                </li>
                                <li className="text-primary before:content-['⮟'] before:mr-3">Documentetion
                                    <ul className="border-l pl-4 text-dark">
                                        <li>DocIndex</li>
                                        <li className="text-primary before:content-['⮟'] before:mr-3">TailwindUi
                                            <ul className="border-l pl-4 text-dark">
                                                <li>Avatars</li>
                                                <li>ButtonsBages</li>
                                                <li>CategoryFilter</li>
                                                <li>CategoryPreviews</li>
                                                <li>CategoryLists</li>
                                                <li>Drawers</li>
                                                <li>FormLayouts</li>
                                                <li>FormLayouts</li>
                                                <li>ModalDialogs</li>
                                                <li>Navbars</li>
                                                <li>PageHeadings</li>
                                                <li>Pagination</li>
                                                <li>ProductFeatures</li>
                                                <li>ProductLists</li>
                                                <li>ProductOverviews</li>
                                                <li>PromoSections</li>
                                                <li>ShoppingCarts</li>
                                                <li>StackedLists</li>
                                                <li className='text-primary'>CodeBox.jsx</li>
                                            </ul>
                                        </li>
                                        <li>Documentation.jsx</li>
                                        <li>DocumentationSIdebarData.jsx</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li>Redux</li>
                <li>App.jsx</li>
                <li className="text-primary">
                    <Link to="../index" target="_blank">index.js</Link>
                </li>
                <li>Routes.jsx</li>
                <li>.gitignore</li>
                <li>package.json</li>
                <li>tailwind.config.js</li>
            </ul>
        </div>
    )

    return (
        <div className="flex justify-center sm:p-5 p-2 bg-white border rounded-2xl">
            <div className="w-full">
                <div className="rounded-2xl card-body border">
                    <div className="p-2 sm:p-5">
                        <div className="flex flex-col space-y-8">
                            {/* x---------------------------------x Getting Started Section x---------------------------------x */}
                            <div className="border border-gray-200 rounded-2xl">
                                <div className="bg-gray-50 rounded-2xl border-b border-gray-200 p-4 sm:p-6">
                                    <h4 className="text-lg sm:text-xl md:text-2xl font-semibold">Getting Started</h4>
                                </div>
                                <div className="p-4 sm:p-6">
                                    <p className="text-base leading-relaxed">
                                        DashBanker is a UI framework built on React & Tailwind CSS, optimized for creating responsive layouts and easily styled components for dashboards and web applications.
                                    </p>
                                </div>
                            </div>

                            {/* x---------------------------------x Tailwind Installation Section x---------------------------------x */}
                            <div className="border border-gray-200 rounded-2xl">
                                <div className="bg-gray-50 rounded-2xl border-b border-gray-200 p-4 sm:p-6">
                                    <h4 className="text-lg sm:text-xl md:text-2xl font-semibold">Installation</h4>
                                </div>
                                <div className="p-4 sm:p-6">
                                    <p className="before:content-['➤'] before:mr-3">
                                        Follow these steps to set up a project with React and Tailwind CSS:
                                    </p>
                                    <ol className="list-decimal space-y-2 my-2 sm:pl-9 pl-2">
                                        <li>Create a new React project folder and initialize it with npm:</li>
                                        <li>
                                            <strong>Set up a new React app:</strong> Use
                                            {/* x---------------------------------x Code Box Component x---------------------------------x */}
                                            <CodeBox code={`npx create-react-app my-tailwind-app`} auto={true} />
                                        </li>
                                        <li>
                                            <strong>Navigate to the project directory:</strong>
                                            {/* x---------------------------------x Code Box Component x---------------------------------x */}
                                            <CodeBox code={`cd my-tailwind-app`} auto={true} />
                                        </li>
                                        <li>
                                            <strong>Install Tailwind CSS:</strong>
                                            {/* x---------------------------------x Code Box Component x---------------------------------x */}
                                            <CodeBox code={`npm install -D tailwindcss postcss autoprefixer`} auto={true} />
                                        </li>
                                        <li>
                                            <strong>Initialize Tailwind CSS:</strong>
                                            {/* x---------------------------------x Code Box Component x---------------------------------x */}
                                            <CodeBox code={`npx tailwindcss init -p`} auto={true} />
                                        </li>
                                        <li>
                                            <strong>Configure Tailwind in `tailwind.config.js`:</strong> Add the paths to your `src` files:
                                            {/* x---------------------------------x Code Box Component x---------------------------------x */}
                                            <CodeBox code={configFile} auto={true} />
                                        </li>
                                        <li>
                                            <strong>Add Tailwind to your CSS:</strong> Open `src/index.css` and include Tailwind’s base, components, and utilities:
                                            {/* x---------------------------------x Code Box Component x---------------------------------x */}
                                            <CodeBox code={`@tailwind base;\n @tailwind components;\n @tailwind utilities;`} auto={true} />
                                        </li>
                                        <li>
                                            <strong>Run the development server:</strong> Start the project to see Tailwind CSS in action:
                                            {/* x---------------------------------x Code Box Component x---------------------------------x */}
                                            <CodeBox code={`npm run start`} auto={true} />
                                        </li>
                                    </ol>

                                </div>
                            </div>

                            {/* x---------------------------------x DashBaker Folder Structure Section x---------------------------------x */}
                            <div className="w-full">
                                <div className="border-t pt-4 mt-4 border-gray-200"></div>
                                <div className="border border-gray-200 rounded-2xl">
                                    <div className="bg-gray-50 rounded-2xl border-b border-gray-200 p-4 sm:p-6">
                                        <h4 id="FolderStructure" className="text-lg sm:text-xl md:text-2xl font-semibold">Project Structure</h4>
                                    </div>
                                    <div className="p-4">
                                        <CodeBox code={ProjectStructure} auto={true} />
                                    </div>
                                </div>
                            </div>

                            {/* x---------------------------------x Template References Section x---------------------------------x */}
                            <div className="w-full">
                                <div className="border-t pt-4 mt-4 border-gray-200"></div>
                                <div className="border border-gray-200 rounded-2xl">
                                    <div className="bg-gray-50 rounded-2xl border-b border-gray-200 p-4">
                                        <h4 className="text-lg font-semibold">DashBaker Template References</h4>
                                    </div>
                                    <div className="p-4">
                                        <div className="overflow-x-auto custom_scroll">
                                            <table className="min-w-full table-auto text-left">
                                                <tbody>
                                                    <tr>
                                                        <td>React JS</td>
                                                        <td><Link to="https://react.dev/" className="text-primary">https://react.dev/</Link></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Google Font</td>
                                                        <td><Link to="https://fonts.google.com/" className="text-primary">https://fonts.google.com/</Link></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Tailwind</td>
                                                        <td><Link to="https://tailwindcss.com/" className="text-primary">https://tailwindcss.com/</Link></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Apex Chart</td>
                                                        <td><Link to="https://apexcharts.com/" className="text-primary">https://apexcharts.com/</Link></td>
                                                    </tr>
                                                    <tr>
                                                        <td>SASS</td>
                                                        <td><Link to="https://sass-lang.com/" className="text-primary">https://sass-lang.com/</Link></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocIndex;
